<template>
  <div>
    <v-data-table
      flat
      item-key="id"
      :headers="$vuetify.breakpoint.mobile ? mobileHeaders : headers"
      :items="courses"
      :search="search"
      disable-sort
      :items-per-page="5"
    >
      <course-list-actions
        class="mb-2"
        slot="top"
        :major="major"
        @updateMajor="updateMajor"
        style="justify-content: flex-end"
      />
      <template v-slot:[`item.status`]="{ item }">
        <v-chip :color="getColor(item.status)" dark>{{ item.status }}</v-chip>
      </template>
      <template v-slot:[`item.title`]="{ item }">
        <router-link :to="'/course/' + item.id" style="text-decoration: none">{{
          item.title
        }}</router-link>
      </template>
      <template v-slot:[`item.code`]="{ item }">
        <router-link :to="'/course/' + item.id" style="text-decoration: none">{{
          item.code
        }}</router-link>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-btn
          icon
          @click="onClickRemoveIcon(item)"
          v-if="['super_admin', 'education_manager'].includes(role.type) && major"
        >
          <v-icon dense>delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog v-model="confirm.isOpen" max-width="548">
      <v-card>
        <v-toolbar color="#FFB300" dense class="elevation-0" dark>
          <v-toolbar-title>{{ confirm.title }}</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="confirm.isOpen = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-4">
          <div v-html="confirm.htmlMessage" />
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn color="primary" @click="confirm.callback"> Xác nhận </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import CourseListActions from '@/modules/major/courses/CourseListActions.vue'

export default {
  components: {
    CourseListActions
  },
  props: {
    role: String,
    major: Object
  },
  data() {
    return {
      confirm: {
        title: '',
        isOpen: false,
        currentItem: null,
        htmlMessage: '',
        callback: () => {}
      },
      headers: [
        { text: 'Tên môn học', value: 'title', align: 'left', sortable: false },
        { text: 'Mã Khóa Học', value: 'code', align: 'left', sortable: true },
        {
          text: 'Mô Tả Khóa Học',
          value: 'description',
          align: 'left',
          sortable: false
        },
        {
          text: 'Hoạt động',
          value: 'action',
          align: 'center'
        }
      ],
      mobileHeaders: [
        { text: 'Tên môn học', value: 'title', align: 'left', sortable: false },
        { text: 'Mã Khóa Học', value: 'code', align: 'left', sortable: true },
        {
          text: 'Hoạt động',
          value: 'action',
          align: 'center'
        }
      ],
      selected: [],
      search: '',
      status: null,
      statuses: [
        { text: 'Active', value: 'false' },
        { text: 'Blocked', value: 'true' }
      ]
    }
  },
  computed: {
    ...mapGetters('majorDetail', ['courses']),
    ...mapState('app', ['department']),
    ...mapState('auth', ['profile', 'role'])
  },
  methods: {
    ...mapActions('majorDetail', ['updateMajor']),
    getColor(status) {
      if (status === 'active') return 'green'
      else return 'red'
    },
    onClickRemoveIcon(item) {
      this.confirm.isOpen = true
      this.confirm.title = 'Xóa khỏi chuyên ngành'
      this.confirm.htmlMessage = `Bạn có muốn bỏ khóa học này ra khỏi chuyên ngành ${this.major.title}?`
      this.confirm.callback = () => {
        const clonedItem = JSON.parse(JSON.stringify(item))
        this.updateMajor({
          id: this.major.id,
          courses: this.major.courses.filter(course => {
            return clonedItem.id !== course.id
          })
        }).then(() => {
          this.confirm.isOpen = false
        })
      }
    }
  }
}
</script>
